import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Filtr va sahifalash holati URL'da yashaydi, komponentda emas.
 *
 * Sabab: moderator hamkasbiga "shu ro'yxatga qara" deb havola tashlaydi
 * va u aynan shu natijani ko'radi. "Orqaga" tugmasi ham kutilganidek
 * ishlaydi. Komponent holati bularning ikkalasini ham bera olmaydi.
 */
export function useUrlFilters<T extends Record<string, string | number | undefined>>(defaults: T) {
  const [searchParams, setSearchParams] = useSearchParams();

  const filters = useMemo(() => {
    const result = { ...defaults } as T;
    for (const key of Object.keys(defaults) as (keyof T)[]) {
      const raw = searchParams.get(String(key));
      if (raw === null) continue;
      result[key] = (typeof defaults[key] === "number" ? Number(raw) : raw) as T[keyof T];
    }
    return result;
  }, [searchParams, defaults]);

  const setFilters = useCallback(
    (patch: Partial<T>, options?: { resetPage?: boolean }) => {
      const next = new URLSearchParams(searchParams);
      for (const [key, value] of Object.entries(patch)) {
        if (value === undefined || value === "" || value === "all") next.delete(key);
        else next.set(key, String(value));
      }
      // Filtr torayganda 7-sahifada turish bo'sh ro'yxat degani.
      if (options?.resetPage !== false && !("page" in patch)) next.delete("page");
      setSearchParams(next, { replace: true });
    },
    [searchParams, setSearchParams],
  );

  return { filters, setFilters };
}
